import { css } from 'styled-components/macro'

export default (...args) => css`
  @media only screen
  and (max-width : 812px)
  and (orientation : portrait) {
    ${css(...args)}
  }
`
